/**
 * Styled Components - Created by gustavomedina on 13/04/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import AntdButton from 'antd/lib/button'

export const Title = styled.div`
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  line-height: 27px;
`

export const Text = styled.div`
  color: #8c8c8c;
  font-size: 13px;
  line-height: 21px;
  margin: 12px 0;
`

export const StyledInput = styled(Input)`
  margin-bottom: 20px;
  margin-top: 0px;
  border-radius: 0px;
  width: 100%;
`
export const StyledSaveAs = styled.div`
  margin-top: 10px;
`

export const Button = styled(AntdButton)`
  height: 40px;
  width: 100%;
  margin-top: 8px;
`

export const ButtonWrapper = styled.div`
  .ant-btn-primary {
    background-color: #4a90e2;
    border-color: #4a90e2;
    width: 100%;
  }
  .ant-btn-primary:hover {
    background-color: #4a90e2;
    border-color: #4a90e2;
  }
`
export const CheckWrapper = styled.div`
  margin-bottom: 10px;
  .ant-checkbox-wrapper:hover,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus + .ant-checkbox-inner {
    border-color: #4a90e2;
  }
  .ant-checkbox-checked .ant-checkbox-inner,
  .ant-checkbox-indeterminate .ant-checkbox-inner {
    background-color: #4a90e2;
  }
`

export const IconBadge = styled.img`
  display: block;
  width: 50px;
  height: 50px;
  padding: 12px;
  box-sizing: border-box;
  object-fit: contain;
  border-radius: var(--radius-full);
  background: var(--neutral-lightest-block);
  flex-shrink: 0;
`

export const ModalHeading = styled.h2`
  margin: 0;
  font: 600 32px/38px var(--font-barlow-semi-condensed);
  color: var(--neutral-darkest);
  text-transform: capitalize;
`

export const Label = styled.p`
  margin: 0;
  display: flex;
  align-items: center;
  gap: var(--spacing-4);
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--neutral-darkest);
  #required-mark {
    font: 500 14px/20px var(--font-barlow);
    letter-spacing: 1px;
    color: var(--neutral-secondary);
  }
`

export const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-12);
  width: 100%;
`

export const Container = styled.div`
  width: 100%;

  &[data-appearance='v2'] {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-24);

    ${Text} {
      margin: 0;
      font: 400 14px/22px var(--font-inter);
      color: var(--neutral-secondary);
    }

    ${StyledInput} {
      margin: 0;
      height: 44px;
      padding: 0 16px;
      background: var(--neutral-fill-lightest);
      border: var(--border-regular) solid var(--neutral-border-med);
      border-radius: 0;
      box-shadow: none;
      font: 400 14px/22px var(--font-inter);
      color: var(--neutral-darkest);
      &::placeholder {
        color: var(--neutral-muted);
      }
      &:focus,
      &:hover {
        border-color: var(--neutral-border-med);
        box-shadow: none;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamPassCode/styledComponents.tsx